// File: frontend/src/context/ColorModeContext.js
//
// The ONE light/dark mode for every PesaFii web application. App.js owns the
// state (persisted as localStorage "themeMode") and provides it above BOTH the
// business application tree and the Ambassador application tree, so the two
// share a single theme engine instead of each growing its own.

import { createContext, useContext } from "react";

export const ColorModeContext = createContext({ mode: "dark", toggleMode: () => {} });
export const useColorMode = () => useContext(ColorModeContext);
